// extracted by mini-css-extract-plugin
module.exports = {"logoClassName":"topClinicalTrialsWrapper_logoClassName__WFU8J"};